<div [@visible]>
  <mat-spinner [color]="'accent'" [diameter]='60'></mat-spinner>
  <span>connecting to server...</span>
</div>
